import script from "./NotificationContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationContainer.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationContainer.vue?vue&type=style&index=0&id=47667211&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47667211"]])

export default __exports__